import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table deposit report view.
 * @extends JetView
 */
export default class recordTableDepositReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Window for advanced filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // DataTable ID for details
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                select: true,
                columns: [
                    {
                        id: 'package',
                        header: _('dav'), // Header for package column
                        fillspace: 2,
                        minWidth: 100,
                        sort: 'text', // Sorting type
                        format: dateFormat, // Date format for the column
                    },
                    {
                        id: 'maintainer',
                        header: _('ID Usuario'), // Header for maintainer column
                        width: 100,
                        sort: 'int', // Sorting type
                    },
                    {
                        id: 'architecture',
                        header: _('Transacción ID'), // Header for architecture column
                        width: 100,
                        sort: 'int', // Sorting type
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true,
            columns: [
                {
                    id: 'package',
                    header: _('dav'), // Header for package column
                    fillspace: 2,
                    minWidth: 100,
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format for the column
                },
                {
                    id: 'maintainer',
                    header: _('ID Usuario'), // Header for maintainer column
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'architecture',
                    header: _('Transacción ID'), // Header for architecture column
                    width: 100,
                    sort: 'int', // Sorting type
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url =
            devConfig.geturlApi() + // API URL for fetching data
            'es/Financial/GetDepositsWithdrawalsWithPaging2';

        // Event listener for user ID changes
        this.on(this.app, 'user:id', (Id) => {
            grid.load(url + '?id=' + Id); // Load grid data based on user ID
            $$('dtDetails').clearAll(); // Clear previous details
            $$('dtDetails').load(url + '?id=' + Id); // Load details based on user ID
        });
    }
}

// FILE DOCUMENTED
